<template>
  <div id="root">
    <div class="container">
      <div
        class="row"
        :class="{
          validationError: validationErrors.nameError,
          noError: !validationErrors.nameError
        }"
      >
        <div class="col-md-12">
          What vacation is this?
        </div>
      </div>
      <div
        class="row"
        :class="{
          validationError: validationErrors.nameError,
          noError: !validationErrors.nameError
        }">
        <div class="col-md-12">
          <el-input
            type="text"
            id="name"
            placeholder="Spring break 2021, Christmas break 2021, etc."
            v-model="name"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p
            v-show="validationErrors.nameError"
            :class="{
              validationErrorText: validationErrors.nameError
            }"
          >
            {{ validationErrors.nameError }}
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p style="margin: 20px 0 0 0;">
            <b>The vacation date must be set for the future. If you have questions,
              please submit a support ticket.</b>
          </p>
        </div>
      </div>
      <div
        class="row"
        :class="{
          validationError: validationErrors.startDateError,
          noError: !validationErrors.startDateError
        }"
      >
        <div class="col-md-4">
          Start date
        </div>
        <div class="col-md-8">
          <datepicker
            class="datepicker"
            placeholder="Select Date"
            v-model="startDate"
            :disabled-dates="{
              to: new Date()
            }"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p
            v-show="validationErrors.startDateError"
            :class="{
              validationErrorText: validationErrors.startDateError
            }"
          >
            {{ validationErrors.startDateError }}
          </p>
        </div>
      </div>
      <div
        class="row"
        :class="{
          validationError: validationErrors.endDateError,
          noError: !validationErrors.endDateError
        }"
      >
        <div class="col-md-4">
          End date
        </div>
        <div class="col-md-8">
          <datepicker
            v-if="!invalidDates"
            class="datepicker"
            placeholder="Select Date"
            v-model="endDate"
          />
          <datepicker
            v-if="invalidDates"
            class="datepicker"
            placeholder="Select Date"
            v-model="endDate"
            :disabled-dates="invalidDates"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p
            v-show="validationErrors.endDateError"
            :class="{
              validationErrorText: validationErrors.endDateError
            }"
          >
            {{ validationErrors.endDateError }}
          </p>
        </div>
      </div>
    </div>
    <div style="float: right">
      <p-button @click="handleClose()">
        Cancel
      </p-button>
      <p-button class="custom-modal-type" @click="validateInput()">
        {{ savingStatus }}
      </p-button>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {
    mapState
} from 'vuex';

export default {
    name: 'NewVacationDatesForm',
    components: {
        Datepicker
    },
    data() {
        return {
            namespace: 'VacationDates',
            name: '',
            startDate: null,
            endDate: null,
            invalidDates: {
                to: new Date()
            },
            validationErrors: {
                nameError: null,
                startDateError: null,
                endDateError: null,
            },
            savingStatus: 'Save',
        };
    },
    computed: {
        ...mapState({
            error: (state) => state.VacationDates.error,
        }),
    },
    watch: {
        startDate() {
            if (this.startDate) {
                if (this.endDate <= this.startDate) {
                    this.endDate = null;
                }
                this.invalidDates = {
                    to: new Date(this.startDate)
                };
            } else {
                this.invalidDates = null;
            }
        },
    },
    methods: {
        validateInput() {
            switch (this.name === '') {
            case true:
                this.validationErrors.nameError = 'Please enter a name.';
                break;
            default:
                this.validationErrors.nameError = null;
            }
            switch (this.startDate == null) {
            case true:
                this.validationErrors.startDateError = 'Please select a start date.';
                break;
            default:
                this.validationErrors.startDateError = null;
            }
            switch (this.endDate == null) {
            case true:
                this.validationErrors.endDateError = 'Please select an end date.';
                break;
            default:
                this.validationErrors.endDateError = null;
            }
            switch (!this.validationErrors.nameError
                    && !this.validationErrors.startDateError && !this.validationErrors.endDateError) {
            case true:
                this.handleSave();
                break;
            default:
                break;
            }
        },
        handleSave() {
            if (this.savingStatus !== 'Saving...please wait') {
                this.savingStatus = 'Saving...please wait';
                const vacationData = {
                    name: this.name,
                    start_date: this.transformJSDateForPayload(this.startDate),
                    end_date: this.transformJSDateForPayload(this.endDate)
                };
                this.$store.dispatch(`${this.namespace}/storeNewVacationDates`, {
                    vacation_date: vacationData
                }).then(
                    this.clearInputs()
                ).catch((error) => {
                    this.savingStatus = 'Save';
                    this.$message(error.response.data.message);
                });
            }
        },
        clearInputs() {
            this.name = '';
            this.startDate = null;
            this.endDate = null;
            this.invalidDates = null;
            this.validationErrors.nameError = '';
            this.validationErrors.startDateError = '';
            this.validationErrors.endDateError = '';
            this.savingStatus = 'Save';
        },
        handleClose() {
            this.clearInputs();
            this.$emit('close');
        },
    },
};
</script>
<style>
.noError {
  border-left: 5px solid white;
}
.validationError {
  border-left: 5px solid red;
  background-color: lightpink;
  font-weight: bold;
}
.validationErrorText {
  color: red;
  font-weight: bold;
  margin: 3px 0 10px 0;
  text-align: center;
}
</style>
